module.exports = __webpack_public_path__ + "img/tutorial-03.0360ea44.svg";